// eslint-disable-next-line jira/filename-case
import React from 'react';
import type { Attributes } from '@atlassian/jira-product-analytics-bridge';
import {
	JSErrorBoundary,
	type JSErrorBoundaryProps,
} from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { useAddErrorBoundaryAnalyticsAttributes } from '../../utils/chunk-error-logging/index.tsx';

export type Props = JSErrorBoundaryProps & {
	attributes?: Attributes;
};

export const ErrorBoundaryWithChunkErrorLogging = (props: Props): React.JSX.Element => {
	const { attributes, children, ...rest } = props;
	const addErrorBoundaryAnalyticsAttributes = useAddErrorBoundaryAnalyticsAttributes(attributes);

	return (
		<JSErrorBoundary {...rest} attributes={addErrorBoundaryAnalyticsAttributes}>
			{children}
		</JSErrorBoundary>
	);
};
